export default __webpack_public_path__ + "static/media/see-detail.5daf2589.svg";